export default "__VITE_ASSET__Dw78_fGg__"